<template>
  <div class="four">

    <!-- Hero 区域 -->
    <div class="cooperate">
      <div class="hero-text-container">
        <h1 class="">越璋合作模式</h1>
        <p class="">多元化合作方案，助力品牌增长</p>
        <p class="">我们提供多种合作模式，满足不同品牌需求，覆盖从</p>
        <p class="">小红书内容营销到私域流量转化的全链路解决方案。</p>
      </div>
    </div>

    <!-- 选择合作模式 区域 -->
    <div class="hzms">
      <div class="hzms-container">
        <div class="hzms-title">选择合作模式</div>
        <div class="hzms-content">
          <div class="con">
            <div :class="{'highlight': activeIndex === (i+1), 'item':true}" v-for="(item,i) in hzmsArr"
                 @click="hzmsClick(item.index)" :key="i">
              <div class="title">{{ item.title }}</div>
              <div class="desc">{{ item.description }}</div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- 合作流程 区域 -->
    <div class="hzlc">
      <div class="hzlc-container">
        <div class="hzlc-title">合作流程</div>
        <div class="hzlc-content">
          <a-timeline pending>
            <a-timeline-item>
              <img class="pic" slot="dot" src="../../assets/images/hzms/hzlc1.png" style="border-radius: 50%;">
              <div class="con">
                <div class="card">
                  <div class="item">
                    <span class="font-semibold">第一步：需求诊断</span>
                  </div>
                </div>
              </div>
            </a-timeline-item>
            <a-timeline-item>
              <img class="pic" slot="dot" src="../../assets/images/hzms/hzlc2.png" >
              <div class="con">
                <div class="card">
                  <div class="item">
                    <span v-if="[1,3,5].indexOf(activeIndex) > -1" class="font-semibold">第二步：测试期(评估KPI)</span>
                    <span v-if="[2,6].indexOf(activeIndex) > -1" class="font-semibold">第二步：评估ROI</span>
                    <template v-if="[4].indexOf(activeIndex) > -1">
                      <span class="font-semibold">第二步：测试期3个月</span>
                      <div class="item-btn">
                        <el-button @click="hqtc" style="background-color: #F20303;" type="primary" size="small">
                          获取套餐
                        </el-button>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </a-timeline-item>
            <a-timeline-item v-if="[1,2,3,5,6].indexOf(activeIndex) > -1">
              <img class="pic" slot="dot" src="../../assets/images/hzms/hzlc3.png">
              <div class="con">
                <div class="card">
                  <div class="item">
                    <span class="font-semibold">第三步：对赌签约</span>
                  </div>
                </div>
              </div>
            </a-timeline-item>
            <!--小红书官号代运营-->
            <a-timeline-item v-if="[4].indexOf(activeIndex) > -1">
              <img class="pic" slot="dot" src="../../assets/images/hzms/hzlc6.png">
              <div class="con">
                <div class="card">
                  <div class="item">
                    <span class="font-semibold">第三步：正式合作</span>
                  </div>
                </div>
              </div>
            </a-timeline-item>
            <a-timeline-item v-if="[1,2,3,5,6].indexOf(activeIndex) > -1">
              <img class="pic" slot="dot" src="../../assets/images/hzms/hzlc4.png">
              <div class="con">
                <div class="card">
                  <div class="item">
                    <span class="font-semibold">第四步：对赌执行</span>
                  </div>
                </div>
              </div>
            </a-timeline-item>
            <a-timeline-item class="timeline5" v-if="[4].indexOf(activeIndex) > -1">
              <img class="pic" slot="dot" src="../../assets/images/hzms/hzlc5.png">
              <div class="con">
                <div class="card">
                  <div class="item">
                    <span class="font-semibold">第四步：结果验收</span>
                  </div>
                </div>
              </div>
            </a-timeline-item>
            <a-timeline-item class="timeline5" v-else>
              <img class="pic" slot="dot" src="../../assets/images/hzms/hzlc5.png">
              <div class="con">
                <div class="card">
                  <div class="item">
                    <span class="font-semibold">第五步：对赌结算</span>
                  </div>
                </div>
              </div>
            </a-timeline-item>
            <a-timeline-item color="#e8e8e8"></a-timeline-item>
          </a-timeline>
        </div>
      </div>
    </div>

    <el-dialog title="小红书官号代运营套餐" :visible.sync="dialogVisibleHQTC" width="45%">
      <div>
        <div style="padding: 5px 0 10px 0">此套餐仅供参考</div>
        <div class="tc-dialog">
          <div class="item">
            <div class="d-title">套餐一</div>
            <div class="m-text"><span>￥15,000</span>/月</div>
            <div class="d-text">
              <div class="d-text-item">
                <i class="el-icon-success"></i>
                <span>8篇原创内容创作</span>
              </div>
              <div class="d-text-item">
                <i class="el-icon-success"></i>
                <span>16篇内容转发推广</span>
              </div>
              <div class="d-text-item">
                <i class="el-icon-success"></i>
                <span>私信咨询维护服务</span>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="d-title">套餐二</div>
            <div class="m-text"><span>￥30,000</span>/月</div>
            <div class="d-text">
              <div class="d-text-item">
                <i class="el-icon-success"></i>
                <span>16篇原创内容创作</span>
              </div>
              <div class="d-text-item">
                <i class="el-icon-success"></i>
                <span>无限制内容转发推广</span>
              </div>
              <div class="d-text-item">
                <i class="el-icon-success"></i>
                <span>私信咨询维护服务</span>
              </div>
              <div class="d-text-item">
                <i class="el-icon-success"></i>
                <span>乘风 & 千帆投流支持</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
<!--        <el-button @click="dialogVisibleHQTC = false">关 闭</el-button>-->
        <!--        <el-button type="primary" @click="dialogVisibleHQTC = false">确 定</el-button>-->
      </span>
    </el-dialog>
  </div>

</template>

<script>
export default {
  components: {},
  data() {
    return {
      dialogVisibleHQTC: false,
      rjuv: '',
      zhl: null,
      kdj: null,
      hzmsArr: [
        {
          index: 1,
          title: '小红书报备',
          description: '全流程合规报备合作，保障品牌安全'
        },
        {
          index: 2,
          title: '小红书非报备保 ROI',
          description: '以结果为导向的合作模式，风险共担'
        },
        {
          index: 3,
          title: '小红书非报备选号',
          description: '精准筛选达人资源，优化投放效果'
        },
        {
          index: 4,
          title: '小红书官号代运营',
          description: '专业团队托管官方账号，提升品牌影响力'
        },
        {
          index: 5,
          title: '小红书聚光投放 (UDS/CID)',
          description: '高效广告投放解决方案，实现精准触达'
        },
        {
          index: 6,
          title: '达人私域保 ROI/CPA',
          description: '构建私域流量池，实现长效用户价值'
        }
      ],
      activeIndex: 1
    };
  },
  created() {
  },
  methods: {
    hqtc() {
      this.dialogVisibleHQTC = true;
    },
    hzmsClick(index) {
      this.activeIndex = index
    }
  },
};
</script>

<style lang='scss' scoped>

.highlight{
  border:1px solid #FFE4E6 !important;
  background-color: #FFE4E6!important;
  color: #1F2937 !important;
}

::v-deep .el-dialog {
  border-radius: 20px;

  .el-dialog__body {
    background-color: #f9fafb;
    padding-top: 0;
    padding-bottom: 40px;
  }
}

.tc-dialog {
  display: flex;
  gap: 30px;

  .item {
    flex: 1;
    padding: 20px;
    background-color: #ffffff;
    border: 1px solid #f4f4f5; /* 可选：添加实体边框，与虚影搭配 */
    border-radius: 15px;
    box-shadow: 0 0 10px #ebecec; /* 核心属性 */

    .d-title {
      font-size: x-large;
      font-weight: bold;
    }

    .m-text {
      padding: 10px 0;

      span {
        font-size: x-large;
        font-weight: bold;
        color: #F20303;
      }
    }

    .d-text {
      display: flex;
      flex-direction: column;
      gap: 8px;

      .d-text-item {
        font-size: 14px;

        i {
          color: #22c55e;
        }

        span {
          padding-left: 5px;
        }
      }
    }
  }
}

.four {
  background-color: #F9FAFB;
  font-size: 15px;

  .cooperate {
    margin: 0 auto;
    margin-top: 100px;
    width: 100%;

    height: 500px;
    background-color: #ffffff;
    background-image: url(../../assets/images/合作模式大图.png);
    background-size: cover; /* 图片充满容器，可能裁剪部分内容 */
    /* 或使用 background-size: contain; 图片完整显示，可能留空白 */
    background-repeat: no-repeat; /* 禁止图片重复 */
    background-position: center; /* 图片居中显示（可选） */

    .hero-text-container {
      margin: 0 auto;
      text-align: center;
      height: 100%;
      width: 80%;
      display: flex;
      -webkit-box-orient: vertical;
      -ms-flex-direction: column;
      flex-direction: column;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: flex-start;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;

      h1 {
        font-size: xxx-large;
        font-weight: bold;
        color: #ffffff;
      }

      p {
        color: #fff;
        font-size: 16px;
      }
    }
  }

  .hzms {
    width: 100%;
    /*height: 520px;*/
    padding-top: 50px;
    background-color: #ffffff;

    .hzms-container {
      width: 80%;
      margin: 0 auto;

      .hzms-title {
        text-align: center;
        padding: 20px;
        font-size: xx-large;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.85);
      }

      .hzms-content {
        margin-left: 50px;
        margin-top: 10px;

        .con {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          align-items: center;
          gap: 15px;
          padding: 10px;

          .item {
            width: 31%;
            height: 120px;
            border: 1px solid #dbd7d7; /* 可选：添加实体边框，与虚影搭配 */
            border-radius: 15px;
            padding: 20px;
            cursor: pointer;

            display: flex;
            flex-direction: column;
            justify-content: center;

            .title {
              font-size: large;
              font-weight: bold;
              padding-bottom: 10px;
            }
          }
        }

      }
    }

  }

  .hzlc {
    width: 100%;
    background-color: #F9F2F2;
    height: 853px;
    padding-top: 30px;

    .hzlc-container {
      width: 55%;
      margin: 0 auto;

      .hzlc-title {
        text-align: center;
        padding: 20px;
        font-size: xx-large;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.85);
      }

      .hzlc-content {
        margin-left: 50px;
        margin-top: 30px;

        .ant-timeline {
          .ant-timeline-item {
            padding: 0 0 30px;

            ::v-deep .ant-timeline-item-head{
              border-radius: 50%;
            }
            ::v-deep .ant-timeline-item-head-custom{
             padding: 0px 0px;
            }
           .pic {
              width: 40px;
            }

            .con {
              margin-left: 20px;
              font-size: 14px;
              color: #7e8690;

              h2 {
                font-weight: bold;
              }

              .card {
                padding: 10px;
                display: flex;
                gap: 20px;

                .font-semibold {
                  color: #262626;
                  font-weight: bold;
                  font-size: medium;
                }

                .item {
                  padding: 20px;
                  background-color: #ffffff;
                  border-radius: 10px;
                  width: 100%;

                  .item-btn {
                    padding: 10px 0;
                    button{
                      background-color: #FF6700;
                      border-color: #FF6700;
                      border-radius: 10px;
                    }
                    img {
                      width: 111px;
                      cursor: pointer;

                    }
                  }
                }
              }
            }
          }

          .timeline5 {
            padding: 0;
          }
        }
      }
    }

  }

}


</style>
